export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_04.9d337544.jpg";